var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('vm-back-top',{attrs:{"duration":400}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }